import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { IRestBaseListResponse, BaseResponse } from '../models/rest/baseResponse';
import { State } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { tap, map } from 'rxjs/operators';

export enum AnswerType {
  Integer,
  Boolean,
  String,
  SingleChoice,
  MultiChoice,
}

export class IncidentQualityAnalysisQuestion {
  Id: number;

  QuestionName: string;
  QuestionTitle: string;
  Question: string;
  PossibleAnswersList: Array<string>;
  AnswerType: AnswerType;
  LeftBorder: string;
  RightBorder: string;
  Visible: boolean;
  Required: boolean;
  IsDeleted: boolean;
  IsSystem: boolean;
}

const baseUrl = 'IncidentsQualityAnalysisQuestion';

export interface IGetAllIncidentQualityQuestions extends IRestBaseListResponse<IncidentQualityAnalysisQuestion> {}

export interface IRestBaseQuestionResponse extends BaseResponse {
  IncidentQualityAnalysisQuestion: IncidentQualityAnalysisQuestion;
}

@Injectable({ providedIn: 'root' })
export class IncidentsQualityAnalysisQuestionService {
  constructor(private _httpClient: HttpClient) {}

  getAllPost(includeDeleted = false, parameters?: any, state: any = {}): Observable<any> {
    let request = JSON.parse(JSON.stringify(state));
    request.parameters = parameters;

    let url = `${baseUrl}/List?includeDeleted=${includeDeleted}`;
    return this._httpClient.post<IRestBaseListResponse<IGetAllIncidentQualityQuestions>>(url, request);
  }

  insertOrUpdate(question): Observable<any> {
    return this._httpClient.put<any>(`${baseUrl}`, { IncidentQualityAnalysisQuestion: question });
  }

  delete(Id): Observable<any> {
    return this._httpClient.delete<any>(`${baseUrl}/` + Id);
  }
}

@Injectable({ providedIn: 'root' })
export class IncidentsQualityAnalysisQuestionListService extends BehaviorSubject<GridDataResult> {
  defaultState: State = {
    skip: 0,
    take: 20,
    group: [],
    filter: { logic: 'and', filters: [] },
    sort: [],
  };

  constructor(private _httpClient: HttpClient) {
    super(null);
  }

  public query(state: State, includeDeleted = false): void {
    this.getList(state, includeDeleted).subscribe((x) => {
      super.next(x);
    });
  }

  public clear(): void {
    super.next(<GridDataResult>{
      data: [],
      total: 0,
    });
  }

  getList(state: State = this.defaultState, includeDeleted = false): Observable<GridDataResult> {
    let params = {
      ...state,
      includeDeleted: includeDeleted,
    };

    return this._httpClient.post<any>(`${baseUrl}/List`, params).pipe(
      map(
        (response) =>
          <GridDataResult>{
            data: response.Groups || response.Data || [],
            total: response.Total,
          },
      ),
    );
  }
}
